import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { useNavigate, useLocation } from "react-router-dom";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import FunctionButton from "../../components/common/FunctionButton";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import InputWrapDiv from "../../components/common/InputWrapDiv";
import TopBoxDiv from "../../components/common/TopBoxDiv";
import ContentInput from "../../components/common/ContentInput";
import ValidMsgSpan from "../../components/common/ValidMsgSpan";
import MessageDialog from "../../components/common/MessageDialog";
import { useTranslation } from "react-i18next";

const ChangePwdPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const userId = location.state?.userId;

  const [pwd, setPwd] = useState("");
  const [newPwd, setNewPwd] = useState("");
  const [cfmNewPwd, setCfmNewPwd] = useState("");

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDialogOpen2, setIsDialogOpen2] = useState(false);
  const [dialogMsg, setDialogMsg] = useState("");
  const [dialogMsg2, setDialogMsg2] = useState("");

  useEffect(() => {
    if (!userId) {
      navigate("/login");
    }
  }, []);

  const handlePwdChange = (e) => {
    setPwd(e.target.value.trim());
  };

  const handleNewPwdChange = (e) => {
    setNewPwd(e.target.value.trim());
  };

  const handleCfmNewPWdChange = (e) => {
    setCfmNewPwd(e.target.value.trim());
  };

  const handleSubmitClick = () => {
    if (!validate()) {
      return;
    }
    api
      .post("/user/changepwd", {
        userId: userId,
        userPwd: pwd,
        newUserPwd: newPwd,
      })
      .then(() => {
        setDialogMsg2(t("L0043"));
        setIsDialogOpen2(true);
      })
      .catch((error) => {
        if (error.response.data.result == "1014") {
          setDialogMsg(t("L1086"));
          setIsDialogOpen(true);
        } else if (error.response.data.result == "1") {
          setDialogMsg(t("L0012"));
          setIsDialogOpen(true);
        }
      });
  };

  const handleConfirm = () => {
    setIsDialogOpen(false);
  };

  const handleConfirm2 = () => {
    setIsDialogOpen2(false);
    navigate("/login");
  };

  const handleCancelClick = () => {
    navigate("/login");
  };

  const [errors, setErrors] = useState({
    validPwd: "",
    validNewPwd: "",
    validNewPwdCfm: "",
    validMsg: t("L0018"),
  });

  const validate = () => {
    let tempErrors = {};
    let isValid = true;
    let regex = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-_])(?=.*[0-9]).{8,20}$/;

    if (!pwd) {
      tempErrors.validPwd = "Current password is required.";
      isValid = false;
    }

    if (!newPwd) {
      tempErrors.validNewPwd = "New Password is required.";
      isValid = false;
    }

    if (!cfmNewPwd) {
      tempErrors.validNewPwdCfm = t("L0041");
      isValid = false;
    }

    if (!regex.test(newPwd)) {
      tempErrors.validMsg = t("L0018");
      isValid = false;
    }

    if (newPwd !== cfmNewPwd) {
      tempErrors.validMsg = t("L0042");
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("L0341"), t("L0038")]}></BreadCrumbDiv>

      <InputWrapDiv>
        <TopBoxDiv value={t("L0038")}></TopBoxDiv>
        <table>
          <tbody>
            <tr>
              <th>
                {t("L0039")}
                {errors.validPwd && (
                  <>
                    <br />
                    <ValidMsgSpan value={errors.validPwd}></ValidMsgSpan>
                  </>
                )}
              </th>
              <td>
                <ContentInput
                  type="password"
                  value={pwd}
                  width="100%"
                  maxLength={250}
                  onChange={handlePwdChange}
                ></ContentInput>
              </td>
            </tr>
            <tr>
              <th>
                {t("L0040")}
                {errors.validNewPwd && (
                  <>
                    <br />
                    <ValidMsgSpan value={errors.validNewPwd}></ValidMsgSpan>
                  </>
                )}
              </th>
              <td>
                <ContentInput
                  type="password"
                  value={newPwd}
                  width="100%"
                  maxLength={250}
                  onChange={handleNewPwdChange}
                ></ContentInput>
              </td>
            </tr>
            <tr>
              <th>
                {t("L0041")}
                {errors.validNewPwdCfm && (
                  <>
                    <br />
                    <ValidMsgSpan value={errors.validNewPwdCfm}></ValidMsgSpan>
                  </>
                )}
              </th>
              <td>
                <ContentInput
                  type="password"
                  value={cfmNewPwd}
                  width="100%"
                  maxLength={250}
                  onChange={handleCfmNewPWdChange}
                ></ContentInput>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="tc">
          {errors.validMsg && (
            <>
              <br />
              <ValidMsgSpan
                className={"f12"}
                value={errors.validMsg}
              ></ValidMsgSpan>
            </>
          )}
        </div>
        <ButtonWrapDiv className="btn_bottom">
          <FunctionButton
            value={t("L0659")}
            className="big"
            onClick={handleSubmitClick}
          ></FunctionButton>

          <FunctionButton
            value={t("L0005")}
            className="big bg_gray"
            onClick={handleCancelClick}
          ></FunctionButton>
        </ButtonWrapDiv>
      </InputWrapDiv>

      {isDialogOpen && (
        <MessageDialog title={t("L0339")} message={dialogMsg}>
          <FunctionButton
            value={t("L0004")}
            onClick={handleConfirm}
          ></FunctionButton>
        </MessageDialog>
      )}

      {isDialogOpen2 && (
        <MessageDialog title={t("L0339")} message={dialogMsg2}>
          <FunctionButton
            value={t("L0004")}
            onClick={handleConfirm2}
          ></FunctionButton>
        </MessageDialog>
      )}
    </div>
  );
};

export default ChangePwdPage;
